import CartOverviewBlock, { CartOverviewBlockProps } from './CartOverviewBlock';
import withInteractor from './CartOverviewBlock.interactor';
import withPresenter from './CartOverviewBlock.presenter';

export type { CartOverviewBlockProps };
export default withInteractor(withPresenter(CartOverviewBlock))
